import { Component } from '@angular/core';
import { CfetBaseComponent } from '../../cfet-core';
@Component({
    selector: 'app-utf-sync-details-page',
    templateUrl: './utf-sync-details-page.component.html',
    styleUrls: ['./utf-sync-details-page.component.scss'],
    standalone: false
})
export class UtfSyncDetailsPageComponent extends CfetBaseComponent {

  constructor() {
    super();
  }

}
